<template>
  <div>
    <div class="downineur" v-for="(item,index) in downlist" :key="index">
      <el-input
        :readonly="true"
        style="width: 100%;color: #0C0D0F"
        placeholder="请输入内容"
        size="small"
        v-model="item.name"
        prefix-icon="el-icon-paperclip"
      >
        <el-button slot="append" icon="el-icon-download" class="nejje" @click="down(item)">下载</el-button>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  //list 下载数组，name文件名 url下载的地址
  name: "Downinpu",
  props: {
    downlist: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    down(row) {
      
      if (row.type == 3) {
        window.open("./附件4业绩申报.docx", "_blank");
      }
      if (row.type == 1) {
        window.open('./贵州省建筑业协会入会申请操作手册.docx','_blank')
      }
      if (row.type == 2) {
        window.open('./附件3贵州省建筑业协会会费收取及使用管理暂行办法.doc','_blank')
      }
      if (row.uid) {
        window.open(this.$baseURL+row.url,'_blank')
      }
    }
  }
};
</script>
<style>
.el-input-group__append,
.el-input-group__prepend {
  background-color: white;
  color: #194abe;
}
</style>
<style scoped lang="less">
.downineur {
  width: 350px;
  margin-top: 10px;
}
.nejje {
  color: #194abe !important;
}
</style>